import type { IAGAlgoDataRow } from "../AlgoTable.types";
import { NEW_STRATEGY_ROW_ID } from "../AlgoTable.types";

interface StrategyIdCellParams {
  value?: string;
  data?: IAGAlgoDataRow;
}

export const StrategyIdCell = (params: StrategyIdCellParams) => {
  const { value, data } = params;
  if (!data) return <span>{value}</span>;

  if (data.id === NEW_STRATEGY_ROW_ID) {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          color: "#9fb0d4",
          fontStyle: "italic",
          fontSize: 13,
        }}
      >
        <span style={{ fontSize: 16, fontWeight: 700, fontStyle: "normal" }}>+</span>
        Start a new strategy
      </span>
    );
  }

  return <span>{value}</span>;
};
